// ==============================
// 파일명 : src/constants/firestore.js
// 역할 : Firestore 주요 컬렉션 이름과
//         필드명을 상수로 관리하는 유틸
// 수정일 : 2025-10-12
// ==============================

export const FIRESTORE_COLLECTIONS = Object.freeze({
    ADMINS: "admins", // [수정] 관리자 컬렉션 이름
  USERS: "users", // [수정] 사용자 컬렉션 이름
  WORD_PACKS: "word_packs", // [수정] 언어팩 컬렉션 이름
  DEVICE_REGISTRY: "device_registry", // [수정] 기기 등록 컬렉션 이름
  USER_PURCHASES: "user_purchases", // [수정] 구매 기록 컬렉션 이름
  PACKS_YOUTUBE: "packsYoutube", // [수정] 언어팩 유튜브 영상 컬렉션 이름
  PACK_VIDEO_UPDATES: "packVideoUpdates", // [수정] 언어팩 영상 갱신 요약 컬렉션 이름
}); // [수정] Firestore 주요 컬렉션 이름

export const FIRESTORE_FIELDS = Object.freeze({
  VIDEOS: "videos", // [수정] 영상 배열 필드 이름
  UPDATED_AT: "updatedAt", // [수정] 일반 업데이트 시각 필드
  VIDEO_COUNT: "videoCount", // [수정] 영상 개수 필드 이름
  CHAPTER_COUNT: "chapterCount", // [수정] 챕터 개수 필드 이름
  CREATED_AT: "createdAt", // [수정] 생성 시각 필드 이름
  PACK_NAME: "name", // [수정] 언어팩 이름 필드
  VIDEOS_UPDATED_AT: "videosUpdatedAt", // [수정] 영상 갱신 시각 필드 이름
  PACK_ID: "packId", // [수정] 언어팩 식별자 필드 이름
});

export const getChaptersPath = (packId) =>
  `${FIRESTORE_COLLECTIONS.WORD_PACKS}/${packId}/chapters`; // [수정] 언어팩 챕터 경로